// REQUIRED IMPORTS
const $ = require('jquery');
import _ from "underscore";
import run from '../../utilities/run';
import render from "../../utilities/render";
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import addressValidationFactory from '../common/AddressValidation.js';
import { handleDisplayFor, setElementsFromScope, setDisabled, setOptionsForSelect } from "../../utilities/selectorHelpers";
import { createPreventDefault, isPresent, formatPhone } from '../../utilities/general';
import { instantiateSelect2 } from "../../utilities/select2able";
import { SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT } from "../../constants";
import EditChecker from '../../components/EditChecker/EditChecker';
import { setSwitchery, instantiateSwitchery } from '../../utilities/instantiateSwitchery';
import { isNull, isNullOrUndefined, isNumber } from 'util';
import timePicker from '../../components/timePicker/timePicker';
import datePicker from '../../utilities/datePicker/index.js'
const modalHtml = require('../../sharedHtml/modal.html');
require("./html/dockNewEdit/dockNewEdit.less");
const dockNewEditHtml =require('./html/dockNewEdit/html/dockNewEdit.html');
const newShiftHtml = require('./html/dockNewEdit/html/newShift.html');
const targetSelector = "#new-edit-dock";
run(targetSelector, (mainEl) => {
 
  
    attachNewEditDock(mainEl);
});

function attachNewEditDock(mainEl){
  const editForm =  mainEl.data("edit-form");
  const copyForm =  mainEl.data("copy-form");
  const dockdata =  mainEl.data("dock-edit-data");
  const saveDockURL = mainEl.data('save-dock-url');
  const dockDetailsPageUrl = mainEl.data("dock-details-url");
    let els ={}
    let elementsMap = {
        addShiftBtn: '.add-shift-btn',
        dayShiftRow: '.day-shift-row',
        submitDockBtn: '.submit-dock-btn',
        copyDockBtn: '.copy-details-btn',
        submitEditDockBtn: '.submit-edit-dock-btn',
        cancelDockBtn: '.cancel-dock-btn',
        
        dayOfWeekCheckbox: '.day-of-week-checkbox',
        addDoorBtn:'.add-door-btn',
        removeDockBtn: '.remove-dock-btn',
        //saveDockConfigBtn: '.save-dock-config-btn',
        removeDockHtmlSec :'.dock-details',
        cancelEditDockBtn:'.cancel-edit-dock-btn',
        dockDetailsFormElement:'#dock-details-form-element',
        addDateBtn :'.add-date-btn',
        addNewFacilityDockBtn:"#add-new-facility-dock-btn"
      }

    function init() {
        setElement();
        
        //initiateTimePickers();
        
        bindEditData();
        bindElement();
        handleSwitchingTypeInput();
      }
      function bindEditData() {
        if(!(editForm || copyForm)){
          initiateTimePickers();
          return;
        }
      if(copyForm){
        mainEl.find('.door-name').val(dockdata.dock.docName+"-Copy");
      }else{
        mainEl.find('.door-name').val(dockdata.dock.docName);
      }
        var docUseArray = dockdata.dock.docUse.split(',');
        mainEl.find('.door-uses').val(docUseArray);
        var docAppointmentTypesArray = dockdata.dock.docAppointmentTypes.split(',');
        mainEl.find('.doorAppointmentTypes').val(docAppointmentTypesArray);
        var x = dockdata.dock.docUseFacilitiesSchedule=="Y"?true:false;
        mainEl.find('.use-master-toggle').prop('checked',x);
        var arr=dockdata.dock.dockShifts;
        var shifts = _.groupBy(_.sortBy(arr, "dosStartTime"), 'dosDay');
        
        for (const day in shifts) {
          var e = shifts[day];
          var i;
          for (i = 0; i < e.length; i++) {
            savedShiftTimes[day.toLowerCase()].push({from:e[i].dosStartTime,to:e[i].dosEndTime});
          }
        }
          

        

        initiateTimePickers();

        // Object.keys(shifts).forEach((key,index) => {
        //   shiftTimes[key.toLowerCase()][0].timeFrom.setTimeFromMilitary(shifts[key][0].dosStartTime);
        //   shiftTimes[key.toLowerCase()][0].timeTo.setTimeFromMilitary(shifts[key][0].dosEndTime);
        // });
       
      }
      function setElement() {
        setElementsFromScope(els, elementsMap, mainEl);
      }
      function bindElement() {
        //els.addShiftBtn.on('click', onAddShiftBtnClick);
        mainEl.on('click', '.remove-shift-btn', onRemoveShiftBtnClick);
        els.dayOfWeekCheckbox.on('change', handleCheckboxChange);
        mainEl.on('click', '.new-shift-add-shift-btn', onAddNewShiftBtnClick);
        mainEl.on('click', '.default-add-shift-btn', onAddShiftBtnClick);
        mainEl.on('click','.submit-dock-btn',onSubmitDockBtnClick);
        mainEl.on('click','.copy-details-btn',onCopyDockBtnClick);
      }
    const dockHtml = render(
        dockNewEditHtml, {
            shiftRows: renderShiftRows()
        }
      );
      
    mainEl.find(".new-edit-dock-configuration").append(dockHtml);
    instantiateSelect2($('.new-dock-form').find('.select2-select'));
    $('.new-dock-form').find('.door-uses').on("change", handleDoorUsesChange);

   function handleDoorUsesChange(){
    handleSwitchingTypeInput();
  }
  
  if(!(editForm || copyForm)){
  function handleSwitchingTypeInput(){
    let doorUsesVal = $('.door-uses  :selected').val();
   
    if (doorUsesVal !== "undefined"){
      renderapmtTypeIAO(doorUsesVal);
    }
  }
  }
  
  let aptTypesIAO = [
    {
      key:'Live Load',
      value:'Live Load'
    },
    {
      Key:'Pickup Empty',
      value:'Pickup Empty'
    },
    {
      key:'Pickup Load',
      value:'Pickup Load'
    },
    {
      key:'Live Unload',
      value:'Live Unload'
    },
    {
      key:'Drop Unload',
      value:'Drop Unload'
    },
    {
      key:'Drop Empty',
      value:'Drop Empty'
    }
    ];
  
  let aptTypesO = [
    {
      key:'Live Load',
     value:'Live Load'
    },
    {
      Key:'Pickup Empty',
      value:'Pickup Empty'
    },
    {
      key:'Pickup Load',
      value:'Pickup Load'
    }
    ];

  let aptTypesI =[
     {
      key:'Live Unload',
      value:'Live Unload'
    },
    {
      key:'Drop Unload',
      value:'Drop Unload'
    },
    {
      key:'Drop Empty',
      value:'Drop Empty'
    }
  ]
  
  let doorUses={
    'Inbound and Outbound' : 'Inbound and Outbound',
    'Outbound only' : 'Outbound only'
  };
  
  function renderapmtTypeIAO(doorUsesVal){
    const aptTypeSelect = $(".doorAppointmentTypes");
     aptTypeSelect.html('');
      if (doorUsesVal == "Inbound and Outbound") {
        $(aptTypesIAO).each(function () {
          let option = $('<option />');
          option.attr('value', this.key).text(this.value);
          aptTypeSelect.append(option);
        });
      }
      else if (doorUsesVal == "Outbound only") {
        $(aptTypesO).each(function () {
          let option = $('<option />');
          option.attr('value', this.key).text(this.value);
          aptTypeSelect.append(option);
        });
      }
      else{
         $(aptTypesI).each(function () {
          let option = $('<option />');
          option.attr('value', this.key).text(this.value);
          aptTypeSelect.append(option);
        });
      }
      aptTypeSelect.addClass("select2 select");
      instantiateSelect2(aptTypeSelect);
  }

    function validateForm(formElement) {
      let validator, validationOpts; 
      validationOpts = {
        ignore: '*:not([name])', 
        rules: {
          // simple rule, converted to {required:true}
          doorname: "required",
          appointmenttype: "required"
         
        },
        debug: true,
        errorPlacement: function (error, element) {
          let appendClosest = $(element).data('error-placement-append-closest');
          if (appendClosest) {
            $(element).closest(appendClosest).append(error);
          } else {
            error.insertAfter(element);
          }
        }
      };
      validator = formElement.validate(validationOpts);
      validator.settings.ignore = ":disabled,:hidden";
  
      if (formElement.valid()) {
        return true;
      } else {
        return false;
      }
    }
    function onSubmitDockBtnClick(e){
      e.preventDefault();
      var doorName = mainEl.find('.door-name').val();
      var doorUses = mainEl.find('.door-uses').val();
      var apptTypes =  mainEl.find('.doorAppointmentTypes').val();
      var useMasteToggle = mainEl.find('.use-master-toggle').is(":checked"); 
      var shiftTimes = getShiftTimes();
      var docId;
      if(editForm) docId = dockdata.dock.docId;
      var dockConfigToSave = {
        docId: docId,
        docName: doorName,
        docUse: doorUses,
        docAppointmentTypes: JSON.stringify(apptTypes).replace(/[\[\]"]/g,'' ),
        docUseFacilitiesSchedule:useMasteToggle?'Y':'N',
        dockShifts:shiftTimes 
      };
      const dockAreaFormEle = mainEl.find('.new-dock-form');
  const isValidOrgForm = validateForm(dockAreaFormEle);
  const isTimesValid = validateCheckbox(dockAreaFormEle,shiftTimes);
   //const isValidTime = validateTimeBlocks();
   const isValidTime =true;
  if(isValidOrgForm && isTimesValid && isValidTime){
      const submitModalFlow = new SubmitModalFlow({
        confirmModalTitle: "Save Dock Configuration",
        confirmModalBody: '<div class="q-pad-all-xl">Once saved this dock scheduled warehouse dock Configuration are assigned to this warehouse.</div>',
        confirmModalBtnText: "Save",
        onConfirmClick: function () {
          let saveDockConfigURL = saveDockURL;
          submitModalFlow.showLoadingModal();
          $.ajax({
            data: 
            {
            dockConfiguration: JSON.stringify(dockConfigToSave)
          },
            url: saveDockConfigURL,
            dataType: "JSON",
            type: 'POST',
            success: function (data) {
              EditChecker.setPageClean();
              submitModalFlow.hideAllModals();
              submitModalFlow.showSuccessModal();
              setTimeout(function () {
                 location.href = dockDetailsPageUrl + "&docId=" + data;
              }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
            },
            error: function (data) {
              submitModalFlow.hideAllModals();
              submitModalFlow.showFailureModal();
            }
          });
        }
      });
      submitModalFlow.init();
      submitModalFlow.showConfirmModal();
    }
      
      
      
    }
function validateCheckbox(){
  let isDisplayed= true;
  els.dayShiftRow.each((index, el) => {
    const $el = $(el);
    const dayOfWeek = $el.data('day-of-week');
    const timePickerArea = $el.find('.time-picker-area');
    const timeFrom = timePicker(timePickerArea.find('.time-picker-from'));
    const timeTo = timePicker(timePickerArea.find('.time-picker-to'));
    const dayOfWeekCheckbox = $el.find('.day-of-week-checkbox');
    let isChecked =dayOfWeekCheckbox.is(':checked');
    let dayShiftRow = $(el).closest('.day-shift-row');
    let timeValidAlert = dayShiftRow.find('.q-alert');
    var timeCheckObj = vaidateDefaultTimeRange(timeFrom.getMilitaryTime(),timeTo.getMilitaryTime());
    if(isChecked && !timeCheckObj.isValid){
      timeValidAlert.show();
      timeValidAlert.html(timeCheckObj.message);
      isDisplayed = false;
    }
    var newShifts = timePickerArea.find('.new-shift');
    if(newShifts.length){
      
      
        if(newShifts.length==1){
          const element = $(newShifts[0]);
      const x = timePicker(element.find('.time-picker-from'));
      const y = timePicker(element.find('.time-picker-to'));
          var newShifttimeCheckObj = vaidateTimeRange(x.getMilitaryTime(),y.getMilitaryTime(),timeTo.getMilitaryTime());
          if( !newShifttimeCheckObj.isValid){
            timeValidAlert.show();
            timeValidAlert.html(newShifttimeCheckObj.message);
            isDisplayed = false;
          }
        }else if(newShifts.length==2){
          const prevelement = $(newShifts[0]);
          const prevx = timePicker(prevelement.find('.time-picker-to'));
          const element = $(newShifts[1]);
          const x = timePicker(element.find('.time-picker-from'));
          const y = timePicker(element.find('.time-picker-to'));
          var newShifttimeCheckObj = vaidateTimeRange(x.getMilitaryTime(),y.getMilitaryTime(),prevx.getMilitaryTime());
          if( !newShifttimeCheckObj.isValid){
            timeValidAlert.show();
            timeValidAlert.html(newShifttimeCheckObj.message);
            isDisplayed = false;
          }
        }


    }
    //$(timePickerArea.find('.new-shift').get(indexToRemove-2)).find('.new-shift-add-shift-btn');

  });
  return isDisplayed;
}

function validateTimeBlocks(){
  let timeCheckObj = true;
  Object.keys(shiftTimes).forEach((key) => {
    var a = shiftTimes[key];
    if(a.length == 2){
       timeCheckObj = vaidateTimeRange(a[1].timeFrom.getMilitaryTime(),a[1].timeTo.getMilitaryTime(),a[0].timeTo.getMilitaryTime());
       //els.dayShiftRow;
    }
  });
  return timeCheckObj.isValid;
}

    function getShiftTimes(){
      const shiftTimesToSave = {};
    
      Object.keys(shiftTimes).forEach((key) => {
        shiftTimesToSave[key] = shiftTimes[key].map((el) => {
          return {
            from: el.timeFrom.getMilitaryTime(),
            to: el.timeTo.getMilitaryTime()
          }
        });
      });
      
      var dosDays=[],p=0;
      Object.keys(shiftTimesToSave).forEach((key) => {
        dosDays[p]={};
        dosDays[p].dosDay = key;
        dosDays[p].dosTime =[];
        dosDays[p].dosTime = shiftTimesToSave[key].map((el) => {
          if(el.from != "Invalid date"){
            return {dosStartTime: el.from,dosEndTime: el.to}
          }
          });
        p++;
      });

      const capitalize = (s) => {
        if (typeof s !== 'string') return ''
        return s.charAt(0).toUpperCase() + s.slice(1)
      }
      var dockShifts=[];
      for (let index = 0; index < dosDays.length; index++) {
        const element = dosDays[index];
        
          const array = element.dosTime;
          if(!(typeof(array[0]) == 'undefined' || array[0] === null))
          {
            for (let j = 0; j < array.length; j++) {
              const dtime = array[j];
              dockShifts.push({dosDay:capitalize(element.dosDay),dosStartTime:dtime.dosStartTime,dosEndTime:dtime.dosEndTime});
            }
          }   
      }
      return dockShifts;
    }
    function renderShiftRows() {
        let days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
        //let days = ['Monday', 'Tuesday'];
        const dayShiftRowHtml = require('./html/dockNewEdit/html/dayShiftRow.html');
        //const rawTemplateHtml = require('./html/timePickerTemplate.html');
        const shiftRow = days.map((day) => {
          return render(dayShiftRowHtml, {
            day
          });
        });
    
        return shiftRow.join('');
    }
    let shiftTimes = {
        monday: [],
        tuesday: [],
        wednesday: [],
        thursday: [],
        friday: [],
        saturday: [],
        sunday: []
      };
      let savedShiftTimes = {
        //Sample data for saved shift times
        monday: [],
       // monday: [],
        tuesday: [],
        wednesday: [],
        thursday: [],
        friday: [],
        saturday: [],
        sunday: []
      };
    function initiateTimePickers() {
        els.dayShiftRow.each((index, el) => {
          const $el = $(el);
          const dayOfWeek = $el.data('day-of-week');
          const timePickerArea = $el.find('.time-picker-area');
          const timeFrom = timePicker(timePickerArea.find('.time-picker-from'));
          const timeTo = timePicker(timePickerArea.find('.time-picker-to'));
          const dayOfWeekCheckbox = $el.find('.day-of-week-checkbox');
          timeFrom.disableTimePicker();
          timeTo.disableTimePicker();
          shiftTimes[dayOfWeek].push({ timeFrom, timeTo });
          if (savedShiftTimes[dayOfWeek].length == 1) {
            dayOfWeekCheckbox.prop('checked', 'true');
            timePickerArea.find('.add-shift-btn').removeClass('disabled');
            timeFrom.enableTimePicker();
            timeTo.enableTimePicker();
            timeFrom.setTimeFromMilitary(savedShiftTimes[dayOfWeek][0].from);
            timeTo.setTimeFromMilitary(savedShiftTimes[dayOfWeek][0].to);
          } else if (savedShiftTimes[dayOfWeek].length > 1 && savedShiftTimes[dayOfWeek].length <= 3) {
            dayOfWeekCheckbox.prop('checked', 'true');
            timePickerArea.find('.default-add-shift-btn').hide();
            timePickerArea.find('.add-shift-btn').removeClass('disabled');
            timeFrom.enableTimePicker();
            timeTo.enableTimePicker();
            timeFrom.setTimeFromMilitary(savedShiftTimes[dayOfWeek][0].from);
            timeTo.setTimeFromMilitary(savedShiftTimes[dayOfWeek][0].to);
            savedShiftTimes[dayOfWeek].shift();
            savedShiftTimes[dayOfWeek].map((shift) => {
              const $newShiftHtml = $(newShiftHtml);
              const timeFrom = timePicker($newShiftHtml.find('.time-picker-from'));
              const timeTo = timePicker($newShiftHtml.find('.time-picker-to'));
              timePickerArea.append($newShiftHtml);
              timeFrom.setTimeFromMilitary(shift.from);
              timeTo.setTimeFromMilitary(shift.to);
              shiftTimes[dayOfWeek].push({ timeFrom, timeTo });
            });
          }
          if (shiftTimes[dayOfWeek].length && shiftTimes[dayOfWeek].length === 3) {
            timePickerArea.find('.add-shift-btn').addClass('disabled');
          }
        });
    }

    function handleCheckboxChange() {
        let isChecked = $(this).is(':checked');
        let dayShiftRow = $(this).closest('.day-shift-row');
        let dayOfWeek = dayShiftRow.data('day-of-week');
        let timeValidAlert = dayShiftRow.find('.q-alert');
        if (isChecked) {
          shiftTimes[dayOfWeek][0].timeFrom.enableTimePicker();
          shiftTimes[dayOfWeek][0].timeTo.enableTimePicker();
          dayShiftRow.find('.add-shift-btn').removeClass('disabled');
          dayShiftRow.find('.default-add-shift-btn').show();
        } else {
          dayShiftRow.find('.new-shift').remove();
          shiftTimes[dayOfWeek].length = 1;
          shiftTimes[dayOfWeek][0].timeFrom.disableTimePicker();
          shiftTimes[dayOfWeek][0].timeTo.disableTimePicker();
          shiftTimes[dayOfWeek][0].timeFrom.resetTime();
          shiftTimes[dayOfWeek][0].timeTo.resetTime();
          dayShiftRow.find('.add-shift-btn').addClass('disabled');
          dayShiftRow.find('.default-add-shift-btn').show();
          timeValidAlert.hide();
        }
      }


      function onAddShiftBtnClick(e) {
        e.preventDefault();
        const timePickerArea = $(this).closest('.time-picker-area');
        const dayOfWeek = timePickerArea.data('day-of-week');
        const timeFromVal = timePicker(timePickerArea.find('.time-picker-from'));
        const timeToVal = timePicker(timePickerArea.find('.time-picker-to'));
        let dayShiftRow = $(this).closest('.day-shift-row');
        let timeValidAlert = dayShiftRow.find('.q-alert');
        var timeCheckObj = vaidateDefaultTimeRange(timeFromVal.getMilitaryTime(),timeToVal.getMilitaryTime());
        if(timeCheckObj.isValid){
            timePickerArea.find('.add-shift-btn').removeClass('disabled');
            timePickerArea.find('.default-add-shift-btn').hide();
            timeValidAlert.hide();
            addNewShifRow(timePickerArea,dayOfWeek);
        }else{
            timeValidAlert.show();
            timeValidAlert.html(timeCheckObj.message);
        }
       
      }

      function onAddNewShiftBtnClick(e) {
        e.preventDefault();
        var btn = $(this);
        const timePickerArea = btn.closest('.time-picker-area');
        const dayOfWeek = timePickerArea.data('day-of-week');
        const shiftToValidate = btn.closest('.new-shift');
        let dayShiftRow = $(this).closest('.day-shift-row');
        let timeValidAlert = dayShiftRow.find('.q-alert');
        let timeFromPreviousVal ;
        let timeToPreviousVal ;
        // if(shiftTimes[dayOfWeek].length > 1){
        //     timeFromPreviousVal = shiftTimes[dayOfWeek][1].timeFrom;
        //     timeToPreviousVal = shiftTimes[dayOfWeek][1].timeTo;
        // }
            timeFromPreviousVal = timePicker(timePickerArea.find('.time-picker-from'));
            timeToPreviousVal = timePicker(timePickerArea.find('.time-picker-to'));
        
        
        const timeFrom = timePicker(shiftToValidate.find('.time-picker-from'));
        const timeTo = timePicker(shiftToValidate.find('.time-picker-to'));
        var timeCheckObj = vaidateTimeRange(timeFrom.getMilitaryTime(),timeTo.getMilitaryTime(),timeToPreviousVal.getMilitaryTime());
        if(timeCheckObj.isValid){
            //btn.closest('.new-shift').find('.remove-shift-btn').hide();
            timeValidAlert.hide();
            btn.hide();
            addNewShifRow(timePickerArea,dayOfWeek);
           
        }else{
            if(timeCheckObj.message){
            timeValidAlert.show();
            timeValidAlert.html(timeCheckObj.message);
            }
        }
      }

      function addNewShifRow(timePickerArea,dayOfWeek){
        const $newShiftHtml = $(newShiftHtml);
        const timeFrom = timePicker($newShiftHtml.find('.time-picker-from'));
        const timeTo = timePicker($newShiftHtml.find('.time-picker-to'));
        shiftTimes[dayOfWeek].push({ timeFrom, timeTo });
        
        timePickerArea.append($newShiftHtml);
        if(shiftTimes[dayOfWeek].length>2){
            $newShiftHtml.find('.new-shift-add-shift-btn').hide();
        }
      }

      function vaidateDefaultTimeRange(timeFromValue,timeToValue, previousShiftEndTimeValue){
        var validTimeMsg={};
        if(timeFromValue=="Invalid date"||timeToValue=="Invalid date"){
            validTimeMsg.isValid = false;
            validTimeMsg.message = "Each selected day requires at least one time block.";
        }else if(timeFromValue>=timeToValue){
            validTimeMsg.isValid = false;
            validTimeMsg.message = "End time cannot be before start time.";
        }else{
            validTimeMsg.isValid = true;
        }
        return validTimeMsg;
      }

      function vaidateTimeRange(timeFromValue,timeToValue, previousShiftEndTimeValue){
        var validTimeMsg={};
        if(timeFromValue=="Invalid date"||timeToValue=="Invalid date"){
            validTimeMsg.isValid = false;
            //validTimeMsg.message = "Each selected day requires at least one time block.";
        }else if(timeFromValue>timeToValue){
            validTimeMsg.isValid = false;
            validTimeMsg.message = "End time cannot be before start time.";
        }else if( !(typeof previousShiftEndTimeValue === "undefined")){
            if(previousShiftEndTimeValue>=timeFromValue){
                validTimeMsg.isValid = false;
                validTimeMsg.message = "Current shift time must be greater than previous shift End time.";
            }else{
                validTimeMsg.isValid = true;
            }
        }else{
            validTimeMsg.isValid = true;
        }
        return validTimeMsg;
      }

      function onRemoveShiftBtnClick(e) {
        e.preventDefault();
        const qalert = $(this).closest('.day-shift-row').find('.q-alert');
        const timePickerArea = $(this).closest('.time-picker-area');
        const dayOfWeek = timePickerArea.data('day-of-week');
        const shiftToRemove = $(this).closest('.new-shift');
        const indexToRemove = shiftToRemove.index();
        const prevAddShift = $(timePickerArea.find('.new-shift').get(indexToRemove-2)).find('.new-shift-add-shift-btn');
        $(shiftToRemove).remove();
        shiftTimes[dayOfWeek].splice(indexToRemove, 1);
        if (shiftTimes[dayOfWeek].length < 25) {
          timePickerArea.find('.add-shift-btn').removeClass('disabled');
        }
        if (shiftTimes[dayOfWeek].length > 1 && shiftTimes[dayOfWeek].length <= 25) {
          //timePickerArea.find('.add-shift-btn').show();
          prevAddShift.show();
          timePickerArea.find('.default-add-shift-btn').hide();
        }
        if (shiftTimes[dayOfWeek].length == 1 ) {
          timePickerArea.find('.default-add-shift-btn').show();
        }
        qalert.hide();
        
       
      }

      function onCopyDockBtnClick (e) {
        e.preventDefault();
        
        let mydocId = mainEl.data("dock-id");
        location.href = editUrl + "&docId=" + mydocId+"&copy=true";
      }

    init();
}



// WEBPACK FOOTER //
// ./src/pages/dockConfigurations/newEditDock.js